export enum CompareAction {

    EQUALLY = 'EQUALLY',
    NOT_EQUAL = 'NOT_EQUAL',
    LESS_OR_EQUAL = 'LESS_OR_EQUAL',
    MORE_OR_EQUAL = 'MORE_OR_EQUAL',
    MORE = 'MORE',
    LESS = 'LESS'
}
